import angular from 'angular';

import component from './fnb-order-queue.component';

const FnbOrderQueue = angular.module('control-room.fnb-order-queue', []).component('crFnbOrderQueue', component);

export default FnbOrderQueue;
